import BaseHistoryRecordModel from '../BaseHistoryRecordModel';

export default class AppDefAdditionalClassificationHistoryRecordModel extends BaseHistoryRecordModel {
    get objectLabel() {
        return 'Additional Classification';
    }
}
